<template>
    <div>
        <div v-if="$vuetify.breakpoint.lgAndUp">
            <v-data-table
                :headers="headers"
                :items="outrights"
                :single-expand="singleExpand"
                :expanded.sync="expanded"
                hide-default-footer
                dense
                item-key="id"
                show-expand
                class="elevation-1"
                style="background:#141C2E;"
            >
                <template v-slot:[`item.start`]="{ item }">
                    <div class="py-5"><v-icon :style="{color: item.start == 'LIVE' ? 'red' : '#45D25C'}" size="30">mdi-circle-small</v-icon>{{ item.start }}</div>
                </template>
                <template v-slot:[`item.category`]="{ item }">
                    <div><v-img :src="item.category" max-width="30" max-heigth="30" style="margin-left: auto; margin-right: auto;"></v-img></div>
                </template>
                <template v-slot:[`item.leagueName`]="{ item }">
                    <div class="font-weight-bold text-h6">{{item.leagueName}}</div>
                </template>
                <template v-slot:[`item.format`]="{ item }">
                    <div>{{item.format}}</div>
                </template>
                <template v-slot:[`item.number_of_teams`]="{ item }">
                    <div style="color:#D28945">{{item.number_of_teams}}</div>
                </template>

                <template v-slot:expanded-item="{ headers, item }">
                    <td :colspan="headers.length" class="pa-0">
                        <v-card flat color="rgba(13, 17, 27, .5)" class="rounded-b-xl rounded-t-0">
                            <v-row no-gutters>
                                <v-col cols="12" lg="6" :class="$vuetify.breakpoint.mdAndDown ? 'pa-3' : 'expand-content-col-left pa-3'">
                                    <v-row class="expand-content-row-head">
                                        <v-col cols="3" class="px-0"><div class="text-caption">TEAM</div></v-col>
                                        <v-col cols="2" class="px-0"><div class="text-caption">% {RATIO)</div></v-col>
                                        <v-col cols="2" class="px-0"><div class="text-caption">YOUR BET</div></v-col>
                                        <v-col cols="3" class="px-0"><div class="text-caption">POSSIBLE PAYOUT</div></v-col>
                                        <v-col cols="2" class="px-0"></v-col>
                                    </v-row>
                                    <v-row v-for="items in item.first_team" :key="items.id" :style="$vuetify.breakpoint.mdAndDown ? '' : 'height:100px'" class="d-flex align-center expand-content-row pr-3">
                                        <v-col cols="3" class="px-0">
                                            <div class="py-1">
                                                <v-img :src="items.team" max-width="35" max-heigth="35" style="margin-left: auto; margin-right: auto;"></v-img>
                                                <div class="pt-1 text-caption">{{items.team_name}}</div>
                                            </div>
                                        </v-col>
                                        <v-col cols="2" class="px-0"><div class="text-caption">{{items.odds}}</div></v-col>
                                        <v-col cols="2" class="px-0"><div class="text-caption">{{items.bet == null ? '₱ 0' : `₱ ${Number(items.bet).toLocaleString()}` }}</div></v-col>
                                        <v-col cols="3" class="px-0"><div class="text-caption" :style="items.possible == null ? '' : 'color:#45D28E;'">{{items.possible == null ? '₱ 0' : `₱ ${Number(items.possible).toLocaleString()}` }}</div></v-col>
                                        <v-col cols="2" class="px-0">
                                            <div v-if="items.bet == null">
                                                <v-chip small rounded color="#D28945" @click="placeBet('first_team', item, items)">PLACE A BET</v-chip>
                                            </div>
                                            <div v-else>
                                                <v-chip small rounded color="#45D28E" class="px-6">ADD BET</v-chip>
                                                <v-chip small rounded color="#D24545" class="mt-2">CANCEL BET</v-chip>
                                            </div>
                                        </v-col>
                                    </v-row>
                                </v-col>
                                <v-col cols="12" lg="6" :class="$vuetify.breakpoint.mdAndDown ? 'pa-3' : 'expand-content-col-right pa-3'">
                                    <v-row class="expand-content-row-head">
                                        <v-col cols="3" class="px-0"><div class="text-caption">TEAM</div></v-col>
                                        <v-col cols="2" class="px-0"><div class="text-caption">% {RATIO)</div></v-col>
                                        <v-col cols="2" class="px-0"><div class="text-caption">YOUR BET</div></v-col>
                                        <v-col cols="3" class="px-0"><div class="text-caption">POSSIBLE PAYOUT</div></v-col>
                                        <v-col cols="2" class="px-0"></v-col>
                                    </v-row>
                                    <v-row v-for="items in item.second_team" :key="items.id" :style="$vuetify.breakpoint.mdAndDown ? '' : 'height:100px'" class="d-flex align-center expand-content-row pr-3">
                                        <v-col cols="3" class="px-0">
                                            <div class="py-1">
                                                <v-img :src="items.team" max-width="35" max-heigth="35" style="margin-left: auto; margin-right: auto;"></v-img>
                                                <div class="pt-1 text-caption">{{items.team_name}}</div>
                                            </div>
                                        </v-col>
                                        <v-col cols="2" class="px-0"><div class="text-caption">{{items.odds}}</div></v-col>
                                        <v-col cols="2" class="px-0"><div class="text-caption">{{items.bet == null ? '₱ 0' : `₱ ${Number(items.bet).toLocaleString()}` }}</div></v-col>
                                        <v-col cols="3" class="px-0"><div class="text-caption" :style="items.possible == null ? '' : 'color:#45D28E;'">{{items.possible == null ? '₱ 0' : `₱ ${Number(items.possible).toLocaleString()}` }}</div></v-col>
                                        <v-col cols="2" class="px-0">
                                            <div v-if="items.bet == null">
                                                <v-chip small rounded color="#D28945" @click="placeBet('second_team', item, items)">PLACE A BET</v-chip>
                                            </div>
                                            <div v-else>
                                                <v-chip small rounded color="#45D28E" class="px-6">ADD BET</v-chip>
                                                <v-chip small rounded color="#D24545" class="mt-2">CANCEL BET</v-chip>
                                            </div>
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>
                            <v-dialog
                                v-model="dialog"
                                width="400"
                                persistent
                                :retain-focus="false"
                            >
                                <v-card dark class="pa-3">
                                    <v-container>
                                        <v-row>
                                            <v-col>
                                                <v-text-field v-model="amount" type="number" hide-spin-buttons suffix="₱" color="inherit" placeholder="0.00" solo light hide-details reverse class="mb-5"></v-text-field>
                                                <div class="float-end">
                                                    <v-btn @click="confirmBet" color="primary" rounded>place bet</v-btn>
                                                    <v-btn @click="cancel" class="ml-2" color="error" rounded>cancel</v-btn>
                                                </div>
                                            </v-col>
                                        </v-row>
                                    </v-container>
                                </v-card>
                            </v-dialog>
                        </v-card>
                    </td>
                </template>
            </v-data-table>
        </div>
        <div v-else>
            <v-list color="#0D111B" class="py-0">
                <v-list-group
                    v-for="item in outrights"
                    :key="item.id"
                    v-model="item.active"
                    :prepend-icon="item.action"
                    no-action
                    color="inherit"
                >
                    <template v-slot:activator>
                        <v-list-item-content>
                            <v-row class="d-flex align-center">
                                <v-col cols="4">
                                    <v-list-item-title>
                                        <div class="text-start" style="font-size: 8px !important;"><v-icon color="#45D28E">mdi-circle-small</v-icon>{{item.start}}</div>
                                    </v-list-item-title>
                                </v-col>
                                <v-col cols="6" class="px-0">
                                    <v-list-item-title>
                                        <div class="text-start font-weight-bold" style="font-size: 10px !important;">{{item.leagueName}}</div>
                                    </v-list-item-title>
                                </v-col>
                                <v-col cols="2">
                                    <v-list-item-title>
                                        <v-img :src="item.category" max-width="15" max-heigth="15" style="margin-left: auto; margin-right: auto; opacity: 50% !important;"></v-img>
                                    </v-list-item-title>
                                </v-col>
                            </v-row>
                        </v-list-item-content>
                    </template>
                    <v-list-item class="px-0" dense>
                        <v-list-item-content style="background:#141C2E !important;" class="py-0">
                            <div v-for="team in item.first_team" :key="team.id">
                                <v-col>
                                    <v-row class="d-flex align-center">
                                        <v-col cols="3">
                                            <v-img :src="team.team" max-width="30" max-heigth="30" style="margin-left: auto; margin-right: auto;"></v-img>
                                            <div class="pt-1 font-weight-bold" style="font-size:10px !important;">{{team.team_name}}</div>
                                        </v-col>
                                        <v-col cols="2" class="px-1">
                                            <div style="font-size:10px !important;">{{team.odds}}</div>
                                        </v-col>
                                        <v-col cols="2" class="px-1">
                                            <div style="font-size:10px !important;">₱ {{team.bet != null ? team.bet : '0.00'}}</div>
                                        </v-col>
                                        <v-col cols="2" class="px-1">
                                            <div :style="team.possible == null ? 'font-size:10px !important;' : 'font-size:10px !important; color:#45D28E !important;'">₱ {{team.possible != null ? team.possible : '0.00'}}</div>
                                        </v-col>
                                        <v-col cols="3">
                                            <div v-if="team.bet == null">
                                                <v-btn x-small color="#D28945" rounded style="font-size: 8px !important;">place bet</v-btn>
                                            </div>
                                            <div v-else>
                                                <v-col class="pl-0 py-0">
                                                    <v-btn x-small color="#45D28E" rounded style="font-size: 8px !important;" class="mb-1">add bet</v-btn>
                                                    <v-btn x-small color="#D24545" rounded style="font-size: 8px !important;">cancel bet</v-btn>
                                                </v-col>
                                            </div>
                                        </v-col>
                                    </v-row>
                                </v-col>
                                <v-divider style="border: 1px solid gray !important;"></v-divider>
                            </div>
                        </v-list-item-content>
                    </v-list-item>
                </v-list-group>
            </v-list>
        </div>
    </div>
</template>
<script>
export default {
    data () {
      return {
        tab: null,
        expanded: [],
        singleExpand: true,
        dialog: false,
        amount: '',
        headers: [
            { text: 'Start', align: 'start', class: 'pl-6', sortable: false, value: 'start' },
            { text: 'Category', align: 'center', sortable: false, value: 'category' },
            { text: 'League Name', align: 'center', sortable: false, value: 'leagueName' },
            { text: 'Format', align: 'center', sortable: false, value: 'format' },
            { text: 'Number of Teams', align: 'center', sortable: false, value: `number_of_teams` },
            { text: '', align: 'center', sortable: false, value: `data-table-expand` }
        ],
        outrights: [
            {
                id: 1,
                start: '3h 7m 22s from now',
                category_name: 'Dota',
                category: require('@/assets/images/Dota.svg'),
                leagueName: "DPC SEA Tour 3: Division II",
                format: "SINGLE ROUND - ROBIN",
                number_of_teams: "EIGHT TEAMS",
                first_team: [
                    {
                        id: 1,
                        team: require('@/assets/images/Virtus.svg'),
                        team_name: 'Virtus.pro',
                        odds: '31.88% (2.97)',
                        bet: '250.00',
                        possible: '742.50'
                    },
                    {
                        id: 2,
                        team: require('@/assets/images/Fnatic.svg'),
                        team_name: 'Fnatic',
                        odds: '26.09% (x3.64)',
                        bet: null,
                        possible: null,
                    },
                    {
                        id: 3,
                        team: require('@/assets/images/Yangon_Galacticos.svg'),
                        team_name: 'Yangon Galacticos',
                        odds: '19.35% (x4.90)',
                        bet: null,
                        possible: null,
                    },
                    {
                        id: 4,
                        team: require('@/assets/images/Boom.svg'),
                        team_name: 'Fnatic',
                        odds: '6.05% (x15.67)',
                        bet: null,
                        possible: null,
                    },
                ],
                second_team: [
                    {
                        id: 5,
                        team: require('@/assets/images/Victory_Five.svg'),
                        team_name: 'Victory Five',
                        odds: '3.37% (x28.16)',
                        bet: '250.00',
                        possible: '1250.50'
                    },
                    {
                        id: 6,
                        team: require('@/assets/images/IG.svg'),
                        team_name: 'Invictus Gaming',
                        odds: '2.13% (x44.53)',
                        bet: null,
                        possible: null,
                    },
                    {
                        id: 7,
                        team: require('@/assets/images/Xerxia.svg'),
                        team_name: 'Xerxia Esports',
                        odds: '4.92% (x19.30)',
                        bet: null,
                        possible: null,
                    },
                    {
                        id: 8,
                        team: require('@/assets/images/RRQ.svg'),
                        team_name: 'RRQ',
                        odds: '6.18% (x15.36)',
                        bet: null,
                        possible: null,
                    },
                ],
            },
            {
                id: 2,
                start: '3h 7m 21s from now',
                category_name: 'LOL',
                category: require('@/assets/images/LOL.svg'),
                leagueName: "LPL SUMMER LEAGUE",
                format: "SINGLE ROUND - ROBIN",
                number_of_teams: "EIGHT TEAMS",
                first_team: [
                    {
                        id: 9,
                        team: require('@/assets/images/Virtus.svg'),
                        team_name: 'Virtus.pro',
                        odds: '31.88% (2.97)',
                        bet: '250.00',
                        possible: '742.50'
                    },
                    {
                        id: 10,
                        team: require('@/assets/images/Fnatic.svg'),
                        team_name: 'Fnatic.pro',
                        odds: '4.56%',
                        bet: null,
                        possible: null,
                    },
                    {
                        id: 11,
                        team: require('@/assets/images/Fnatic.svg'),
                        team_name: 'Fnatic.pro',
                        odds: '4.56%',
                        bet: null,
                        possible: null,
                    },
                    {
                        id: 12,
                        team: require('@/assets/images/Fnatic.svg'),
                        team_name: 'Fnatic.pro',
                        odds: '4.56%',
                        bet: null,
                        possible: null,
                    },
                ],
                second_team: [
                    {
                        id: 13,
                        team: require('@/assets/images/Virtus.svg'),
                        team_name: 'Virtus.pro',
                        odds: '31.88% (2.97)',
                        bet: '250.00',
                        possible: '742.50'
                    },
                    {
                        id: 14,
                        team: require('@/assets/images/Fnatic.svg'),
                        team_name: 'Fnatic.pro',
                        odds: '4.56%',
                        bet: null,
                        possible: null,
                    },
                    {
                        id: 15,
                        team: require('@/assets/images/Fnatic.svg'),
                        team_name: 'Fnatic.pro',
                        odds: '4.56%',
                        bet: null,
                        possible: null,
                    },
                    {
                        id: 16,
                        team: require('@/assets/images/Fnatic.svg'),
                        team_name: 'Fnatic.pro',
                        odds: '4.56%',
                        bet: null,
                        possible: null,
                    },
                ],
            },
            {
                id: 3,
                start: '4h 22m 18s from now',
                category_name: 'Dota',
                category: require('@/assets/images/Dota.svg'),
                leagueName: "DPC CIS Tour 3: Division II",
                format: "SINGLE ROUND - ROBIN",
                number_of_teams: "EIGHT TEAMS",
                first_team: [
                    {
                        id: 17,
                        team: require('@/assets/images/Virtus.svg'),
                        team_name: 'Virtus.pro',
                        odds: '31.88% (2.97)',
                        bet: '250.00',
                        possible: '742.50'
                    },
                    {
                        id: 18,
                        team: require('@/assets/images/Fnatic.svg'),
                        team_name: 'Fnatic',
                        odds: '26.09% (x3.64)',
                        bet: null,
                        possible: null,
                    },
                    {
                        id: 19,
                        team: require('@/assets/images/Yangon_Galacticos.svg'),
                        team_name: 'Yangon Galacticos',
                        odds: '19.35% (x4.90)',
                        bet: null,
                        possible: null,
                    },
                    {
                        id: 20,
                        team: require('@/assets/images/Boom.svg'),
                        team_name: 'Fnatic',
                        odds: '6.05% (x15.67)',
                        bet: null,
                        possible: null,
                    },
                ],
                second_team: [
                    {
                        id: 21,
                        team: require('@/assets/images/Victory_Five.svg'),
                        team_name: 'Victory Five',
                        odds: '3.37% (x28.16)',
                        bet: '250.00',
                        possible: '742.50'
                    },
                    {
                        id: 22,
                        team: require('@/assets/images/IG.svg'),
                        team_name: 'Invictus Gaming',
                        odds: '2.13% (x44.53)',
                        bet: null,
                        possible: null,
                    },
                    {
                        id: 23,
                        team: require('@/assets/images/Xerxia.svg'),
                        team_name: 'Xerxia Esports',
                        odds: '4.92% (x19.30)',
                        bet: null,
                        possible: null,
                    },
                    {
                        id: 24,
                        team: require('@/assets/images/RRQ.svg'),
                        team_name: 'RRQ',
                        odds: '6.18% (x15.36)',
                        bet: null,
                        possible: null,
                    },
                ],
            },
        ],
        main: {},
        sub: {},
        team: '',
      }
    },
    methods: {
        placeBet(team, main, sub) {
            if(this.main != main) {
                this.main = main;
            }
            if(this.sub != sub) {
                this.sub = sub;
            }
            this.team = team;
            this.dialog = true;
        },
        confirmBet() {
            let tmpmain = this.outrights.indexOf(this.main);
            if (this.team == 'first_team') {
                let tmpsub = this.outrights[tmpmain].first_team.indexOf(this.sub);
                this.outrights[tmpmain].first_team[tmpsub].bet = this.amount;
            } else {
                let tmpsub = this.outrights[tmpmain].second_team.indexOf(this.sub);
                this.outrights[tmpmain].second_team[tmpsub].bet = this.amount;
            }
            this.amount = '';
            this.dialog = false;
        },
        cancel() {
            this.amount = '';
            this.dialog = false;
        }
    }
};
</script>
<style scoped>
.v-data-table >>> div > table > tbody > tr > td {
    background-color:rgba(13, 17, 27, .75);
    padding-bottom: 5px !important;
}
.v-data-table >>> div > table > thead > tr > th {
    border: none !important;
}
.v-data-table >>> div > table > tbody > tr > td:nth-child(2) > div > div {
    opacity: 50%;
}
.v-data-table >>> div > table > tbody > tr:hover:not(.v-data-table__empty-wrapper) {
    background-color: rgba(13, 17, 27, 1) !important;
}
.v-data-table >>> div > table > tbody > tr:hover:not(.v-data-table__empty-wrapper) > td:nth-child(2) > div > div {
    opacity: 100%;
}
.v-data-table__expanded__content > td {
    background-color: #141C2E !important;
    border-bottom: none !important;
}
.v-data-table__expanded .v-data-table__expanded__content {
    text-indent: 0;
    border: 1px solid blue !important;
}
.expand-content-row-head {
    border-bottom: 1px solid rgba(255, 255, 255, .5) !important;
}
.expand-content-row {
    border-top: 1px solid rgba(255, 255, 255, .25) !important;
}
.expand-content-col-left {
    border-right: 1px solid rgba(255, 255, 255, .25) !important;
}
.expand-content-col-right {
    border-left: 1px solid rgba(255, 255, 255, .25) !important;
}
</style>
<style>
.v-dialog {
    box-shadow: none !important;
}
.v-list-group__header {
    padding: 0 !important;
    padding-right: 6px !important;
}
</style>